"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCommandOptions = void 0;
/**
 * @debt refactor "factorize with other expressions"
 */
const toCommandOptions = (conditionParser) => {
    const ExpressionAttributeNames = {};
    conditionParser.expressionAttributeNames.forEach((expressionAttributeName, index) => {
        ExpressionAttributeNames[`#${conditionParser.expressionAttributePrefix}${index + 1}`] =
            expressionAttributeName;
    });
    const ExpressionAttributeValues = {};
    conditionParser.expressionAttributeValues.forEach((expressionAttributeValue, index) => {
        ExpressionAttributeValues[`:${conditionParser.expressionAttributePrefix}${index + 1}`] =
            expressionAttributeValue;
    });
    const ConditionExpression = conditionParser.expression;
    return {
        ExpressionAttributeNames,
        ExpressionAttributeValues,
        ConditionExpression
    };
};
exports.toCommandOptions = toCommandOptions;
